import { render, staticRenderFns } from "./ProjectInfoProperties.vue?vue&type=template&id=67ed7b84"
import script from "./ProjectInfoProperties.vue?vue&type=script&lang=ts"
export * from "./ProjectInfoProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ed7b84')) {
      api.createRecord('67ed7b84', component.options)
    } else {
      api.reload('67ed7b84', component.options)
    }
    module.hot.accept("./ProjectInfoProperties.vue?vue&type=template&id=67ed7b84", function () {
      api.rerender('67ed7b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectInfoProperties.vue"
export default component.exports